const Player = ({ size = 24, color = "#ffffff" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.4997 11.6665H17.4997C11.0564 11.6665 5.83301 16.8898 5.83301 23.3332V46.6665C5.83301 53.1098 11.0564 58.3332 17.4997 58.3332H52.4997C58.943 58.3332 64.1663 53.1098 64.1663 46.6665V23.3332C64.1663 16.8898 58.943 11.6665 52.4997 11.6665Z"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.7493 35L29.166 26.25V43.75L43.7493 35Z"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Player;
